/* @flow */

export default {
  root: {
    marginTop: 44,
  },

  form: {
    display: 'flex',
    flexDirection: 'column',

    padding: 8,
  },

  legend: {
    paddingTop: 4,
    marginBottom: 24,
  },

  btnContainer: {
    display: 'flex',
    justifyContent: 'center',
  },

  submitBtn: {
    margin: '40px 0',
  },

  intro: {
    WebkitFontSmoothing: 'antialiased',
  },

  avatarSubmitBtn: {
    display: 'flex',
    justifyContent: 'center',

    margin: '-18px auto 0',
  },

  helper: {
    display: 'block',

    marginTop: 16,

    textAlign: 'center',
  },
};
